import * as React from "react";
import { COLOR_SCHEME_DARK, COLOR_SCHEME_LIGHT } from "theme/constants";
import ThemeEditorColor from "./ThemeEditorColor";
const ThemeEditorRow = ({ colorType, colorKey, colorName, currentThemeColors, onChange }) => {
  const light = currentThemeColors == null ? void 0 : currentThemeColors[COLOR_SCHEME_LIGHT][colorType][colorKey];
  const dark = currentThemeColors == null ? void 0 : currentThemeColors[COLOR_SCHEME_DARK][colorType][colorKey];
  const handleChangeLight = (hex) => {
    onChange({ mode: COLOR_SCHEME_LIGHT, key: colorKey, type: colorType, hex });
  };
  const handleChangeDark = (hex) => {
    onChange({ mode: COLOR_SCHEME_DARK, key: colorKey, type: colorType, hex });
  };
  return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("span", null, colorName), /* @__PURE__ */ React.createElement(ThemeEditorColor, { color: light, onChange: handleChangeLight, label: `edit light ${colorName} color` }), /* @__PURE__ */ React.createElement(ThemeEditorColor, { color: dark, onChange: handleChangeDark, label: `edit dark ${colorName} color` }), /* @__PURE__ */ React.createElement("span", null));
};
export default ThemeEditorRow;
